import { useQuery } from "react-query";

import {
  USER_DATA_SOURCES_QUERY_KEY,
  UserDataSourcePreferenceItem,
  fetchUserDataSources
} from "api/dataSource";

export function getPrimarySourceDisplayName(
  sourceDb: string | undefined,
  sources: UserDataSourcePreferenceItem[]
): string {
  const target = sourceDb
    ? sources.find((s) => s.sourceDb === sourceDb)
    : sources.find((s) => s.sourceDb === "gdcDB") ?? sources[0];
  return target?.dataSourceDisplayName ?? target?.dataSourceName ?? "gDC";
}

export function useSurveyDataSources(): UserDataSourcePreferenceItem[] {
  const { data } = useQuery(USER_DATA_SOURCES_QUERY_KEY, fetchUserDataSources, {
    select: (response) => {
      if (response.ok) {
        const category = response.value.find((c) => c.category === "SurveyData");
        return category?.dataSources ?? [];
      }
      return [];
    }
  });
  return data ?? [];
}
